import "./CardProduct.css.ts.vanilla.js";
var o = "koxz7a7", r = "koxz7a5", k = "koxz7a6", e = "koxz7a4", v = "koxz7ac", x = "koxz7ae", t = "koxz7ad", z = "koxz7aa", d = "koxz7a8", c = "koxz7ab", i = "koxz7a9", n = "koxz7a2", u = "koxz7a1", b = "koxz7a0", l = "koxz7a3";
export {
  o as backgroundImage,
  r as backgroundImageOverlay,
  k as backgroundVideo,
  e as backgroundVideoOverlay,
  v as bottom,
  x as buttonIcon,
  t as buttonLink,
  z as carouselContainer,
  d as carouselRoot,
  c as carouselSlide,
  i as carouselViewport,
  n as header,
  u as isEditMode,
  b as root,
  l as title
};
